function onSwymLoadCallback(swat) {
  swat.evtLayer.addEventListener("sw:addedtocart", function (e) {
    var data = e.detail.d.productData;
    wishlistAddToCart(data);
  });
}
if (!window.SwymCallbacks) {
  window.SwymCallbacks = [];
}
window.SwymCallbacks.push(onSwymLoadCallback);

function wishlistAddToCart(data) {
  let formData = {
    items: [
      {
        id: data.id,
        quantity: 0
      },
    ],
  };

  formData["sections"] = "cart-drawer,cart-icon-bubble";
  formData["sections_url"] = "/cart";

  fetch(window.Shopify.routes.root + "cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(formData),
  })
    .then((response) => {
      return response.json();
    })
    .then((data) => {
      let productId = data.id;
      let cartDrawerElement =
        document.querySelector("cart-notification") ||
        document.querySelector("cart-drawer");
        
      if (cartDrawerElement.classList.contains("is-empty")) {
        cartDrawerElement.classList.remove("is-empty");
      }
      cartDrawerElement.renderContents(data);
    })
    .catch((error) => {
      console.error("Error:", error);
    });
}